import { useNavigate } from "react-router-dom"
import { useToast } from "@/contexts/ToastContext"
import FaceCapture from "@/components/Organisms/FaceCapture"
import { updateFaceImage, checkFaceHikvision } from "../service/UsersService"

const FaceCapturePage = () => {
  const navigate = useNavigate()
  const toast = useToast()

  async function handleCapture(file: File) {
    const formData = new FormData()
    formData.append("faceImage", file)

    try {
      const faceCheckResponse: any = await checkFaceHikvision(formData)

      if (faceCheckResponse.status === 200) {
        const updateFaceImageFormData = new FormData()
        updateFaceImageFormData.append("faceImage", file)

        await updateFaceImage(updateFaceImageFormData)
        toast.success("Biometria cadastrada com sucesso!")
        navigate("/profile")
      } else {
        toast.danger("Verifique com seu GS e tente novamente.")
      }
    } catch {
      toast.danger("Erro ao processar o reconhecimento facial. Tente novamente.")
    }
  }
  return <FaceCapture onCapture={handleCapture} />
}
export default FaceCapturePage
